import React, { useState, useEffect } from 'react';
import { FormGroup, Input, Label } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import { actions } from '../../context';

const LocationScopeSelector = ({ practiceId, selectedLocationIds, onChange, disabled }) => {
    const dispatch = useDispatch();
    const locations = useSelector((state) => state.practiceLocations.locations);
    const loading = useSelector((state) => state.practiceLocations.loading);

    const [filter, setFilter] = useState('');

    useEffect(() => {
        if (practiceId && locations.length === 0 && !loading) {
            dispatch(actions.practiceLocations.fetchPracticeLocations(practiceId));
        }
    }, [practiceId, locations.length, loading, dispatch]);

    const isFullAccess = selectedLocationIds.length === 0;

    const filteredLocations = locations.filter((loc) => {
        if (!filter) return true;
        const lowerFilter = filter.toLowerCase();
        return (
            (loc.name && loc.name.toLowerCase().includes(lowerFilter)) ||
            (loc.locationId && loc.locationId.toLowerCase().includes(lowerFilter))
        );
    });

    const toggleLocation = (locId) => {
        let newIds;
        if (selectedLocationIds.includes(locId)) {
            newIds = selectedLocationIds.filter((id) => id !== locId);
        } else {
            newIds = [...selectedLocationIds, locId];
        }
        if (newIds.length === 0) {
            onChange([]);
        } else {
            onChange(newIds);
        }
    };

    const switchToSpecific = () => {
        if (selectedLocationIds.length > 0) {
            onChange(selectedLocationIds);
        } else {
            onChange([locations[0].id]);
        }
    };

    if (locations.length === 0) {
        return (
            <p className="text-muted">
                No locations configured for this practice. All partner access is full-practice.
            </p>
        );
    }

    return (
        <div>
            <h6>Location Access</h6>
            <FormGroup check>
                <Label check>
                    <Input
                        type="radio"
                        checked={isFullAccess}
                        onChange={() => onChange([])}
                        disabled={disabled}
                    />{' '}
                    Full Practice Access
                </Label>
            </FormGroup>
            <FormGroup check>
                <Label check>
                    <Input
                        type="radio"
                        checked={!isFullAccess}
                        onChange={switchToSpecific}
                        disabled={disabled}
                    />{' '}
                    Specific Locations
                </Label>
            </FormGroup>

            {!isFullAccess && (
                <div className="border rounded p-2 mt-2">
                    {locations.length > 10 && (
                        <Input
                            placeholder="Search locations..."
                            value={filter}
                            onChange={(e) => setFilter(e.target.value)}
                            className="mb-2"
                        />
                    )}
                    {filteredLocations.map((loc) => (
                        <FormGroup check key={loc.id}>
                            <Label check>
                                <Input
                                    type="checkbox"
                                    checked={selectedLocationIds.includes(loc.id)}
                                    onChange={() => toggleLocation(loc.id)}
                                    disabled={disabled}
                                />{' '}
                                {loc.locationId} &mdash; {loc.name}
                            </Label>
                        </FormGroup>
                    ))}
                </div>
            )}
        </div>
    );
};

export default LocationScopeSelector;
